/* kbn-gift-claim.js
 * ============================================================================
 * KBN — Geschenk-Claim / On-Site-Kommunikation für den Newsletter-Geschenk-Flow
 * ----------------------------------------------------------------------------
 * Die Geschenk-MECHANIK macht die App "EG Auto Add to Cart" (intern "EasyGift"):
 * Der Magic-Link aus der Klaviyo-Bestätigungsmail (…/?aca=<token>) schaltet das
 * Geschenk frei, und sobald irgendein Artikel im Warenkorb liegt, legt EG das
 * Geschenk (Produkt mit Tag ADD-GIFT) automatisch gratis dazu.
 *
 * Dieses Skript macht NICHT die Mechanik — es macht die KOMMUNIKATION drumherum,
 * damit der Kunde nach dem Klick versteht, dass er aktiv ist UND dass er etwas
 * in den Warenkorb legen muss, damit das Geschenk erscheint.
 *
 * --- Wie wir "ist aktiv?" erkennen ------------------------------------------
 * EG setzt seinen Magic-Link-Cookie httpOnly (server-seitig, für JS UNSICHTBAR).
 * ABER EG spiegelt den aktiven Zustand in localStorage:
 *
 *   EASYGIFT_TARGETING_RULES = {
 *     "value": [ { "value": "<aca-token>", "timestamp": "<ISO>" } ],
 *     "timestamp": "<ISO>"
 *   }
 *
 * Wir lesen also DIREKT EGs Zustand (perfekter Sync) und prüfen den Zeitstempel
 * gegen die Gültigkeit (= EGs "Magic link cookie lifetime"). Das eigene
 * ?aca=-Flag bleibt nur als Fallback, falls EG sein Storage-Format mal ändert.
 *
 * Global geladen über layout/theme.liquid. Die Gültigkeit (Tage) kommt aus dem
 * Theme-Setting (Cart-Drawer → "Geschenk-Hinweis") via window.KBN_GIFT_TTL_DAYS.
 * ============================================================================
 */
(function () {
  'use strict';

  if (window.__KBN_GIFT_CLAIM_INIT__) return;
  window.__KBN_GIFT_CLAIM_INIT__ = true;

  var PARAM = 'aca'; // Magic-Link-Parameter der EG-App

  // EGs Client-Spiegel des Magic-Link-Zustands.
  var EG_RULES_KEY = 'EASYGIFT_TARGETING_RULES';

  // Geschenk-Regel(n) per aca-Token. Leeres Array = JEDE aktive EG-Magic-Link-
  // Regel zählt. WICHTIG: Wenn die EG-Regel neu angelegt wird, ändert sich das
  // Token — dann hier aktualisieren (Token = der Wert hinter ?aca= im Magic-Link).
  var GIFT_TOKENS = ['6867a24c1b9bc00a0f1c50ab'];

  // Eigenes Fallback-Flag (nur falls EGs Storage-Format mal wegfällt).
  var FLAG_KEY = 'kbn-gift:active';
  var UNTIL_KEY = 'kbn-gift:active-until';

  function now() { return Date.now(); }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  // Gültigkeit (Tage) = EGs "Magic link cookie lifetime". Kommt aus dem
  // Theme-Setting (cart-drawer.liquid gibt window.KBN_GIFT_TTL_DAYS aus).
  // EG legt im localStorage nur einen Zeitstempel ab (keinen Ablauf), wir
  // rechnen ihn selbst aus. Bei EG-Änderung nur das Setting anpassen — fertig.
  function ttlMs() {
    var d = (typeof window.KBN_GIFT_TTL_DAYS === 'number' && window.KBN_GIFT_TTL_DAYS > 0)
      ? window.KBN_GIFT_TTL_DAYS : 2;
    return d * 24 * 60 * 60 * 1000;
  }

  // --- Fallback: ?aca=… in Query ODER Hash → eigenes Flag setzen ------------
  function detectMagicLink() {
    try {
      var qs = new URLSearchParams(window.location.search || '');
      var hp = new URLSearchParams((window.location.hash || '').replace(/^#/, ''));
      if (qs.get(PARAM) || hp.get(PARAM)) activate();
    } catch (e) {}
  }
  function activate() {
    lsSet(FLAG_KEY, '1');
    lsSet(UNTIL_KEY, String(now() + ttlMs()));
  }

  // --- PRIMÄR: EGs eigenen Zustand lesen ------------------------------------
  function readEgActive() {
    try {
      var raw = lsGet(EG_RULES_KEY);
      if (!raw) return false;
      var data = JSON.parse(raw);
      var arr = data && data.value;
      if (!Array.isArray(arr)) return false;
      var nowMs = now();
      var ttl = ttlMs();
      for (var i = 0; i < arr.length; i++) {
        var entry = arr[i];
        if (!entry || typeof entry.value !== 'string') continue;
        if (GIFT_TOKENS.length && GIFT_TOKENS.indexOf(entry.value) === -1) continue;
        var t = Date.parse(entry.timestamp || '');
        if (t && (nowMs - t) < ttl) return true;
      }
      return false;
    } catch (e) { return false; }
  }

  function fallbackActive() {
    if (lsGet(FLAG_KEY) !== '1') return false;
    var until = parseInt(lsGet(UNTIL_KEY) || '0', 10);
    return !!until && until >= now();
  }

  function isActive() {
    return readEgActive() || fallbackActive();
  }

  // --- Leer-Hinweis im Cart-Drawer einblenden -------------------------------
  function revealEmptyHint() {
    if (!isActive()) return;
    var cards = document.querySelectorAll('.kbn-gift-empty__card[hidden]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      card.removeAttribute('hidden');
      (function (c) {
        requestAnimationFrame(function () { c.classList.add('is-in'); });
      })(card);
    }
  }

  // --- Persistenter Reminder: vorhandenen Cart-Dot aktivieren ---------------
  // Statt eines eigenen Badges nutzen wir den ohnehin vorhandenen Header-
  // Cart-Dot (.header__cart-dot). Solange das Geschenk aktiv ist, schalten
  // wir ihn sichtbar (is-visible) — kein zusätzliches Markup, kein Layout-
  // Shift. Den leeren-Korb-Fall steuert sonst das Theme via cart.empty?;
  // wir ergänzen nur den Geschenk-Grund und entfernen die Klasse nie aktiv
  // (das Theme setzt sie bei Warenkorb-Änderungen ohnehin neu).
  function revealCartDot() {
    if (!isActive()) return;
    var dots = document.querySelectorAll('.header__cart-dot');
    for (var i = 0; i < dots.length; i++) dots[i].classList.add('is-visible');
  }

  // --- Einmalige Begrüßungs-Animation beim ersten aktiven Seitenaufruf ------
  // Beim ERSTEN Load, an dem das Geschenk aktiv ist (Kunde kam frisch über den
  // Magic-Link), öffnet sich der Cart-Drawer einmal automatisch (zeigt sofort
  // den "Dein Geschenk ist aktiv"-Hinweis) und Cart-Icon + Cart-Dot spielen
  // einen kurzen Success-Cue. Bewusst KEIN zweites Modal direkt nach dem
  // Newsletter-Popup. Gemerkt über ein eigenes Flag mit demselben Zeitfenster
  // wie die Gültigkeit → feuert genau EINMAL pro Aktivierungs-Fenster; danach
  // bleibt nur der stille Cart-Dot + der Hinweis im leeren Warenkorb.
  // Trigger über isActive() (nicht über den ?aca=-Param), damit es auch greift,
  // falls die EG-App den Param vor uns aus der URL entfernt.
  var WELCOME_KEY = 'kbn-gift:welcomed-until';

  function alreadyWelcomed() {
    var until = parseInt(lsGet(WELCOME_KEY) || '0', 10);
    return !!until && until >= now();
  }

  function openCartDrawerOnce() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('cart-drawer').then(function () {
      var d = document.querySelector('cart-drawer');
      if (!d || typeof d.show !== 'function' || d.open) return;
      try { d.show(); } catch (e) { return; }
      // Karten-Slide-in einmal neu auslösen, jetzt wo der Drawer sichtbar ist.
      var card = document.querySelector('.kbn-gift-empty__card:not([hidden])');
      if (card) { card.classList.remove('is-in'); void card.offsetWidth; card.classList.add('is-in'); }
    });
  }

  function runWelcome() {
    revealEmptyHint();
    revealCartDot();
    var go = function () { setTimeout(openCartDrawerOnce, 450); };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  }

  function maybeWelcome() {
    if (!isActive() || alreadyWelcomed()) return;
    lsSet(WELCOME_KEY, String(now() + ttlMs()));
    runWelcome();
  }

  // --- Init + Event-Hooks (gespiegelt von kb-cart-goal.js) ------------------
  detectMagicLink();

  function run() { revealEmptyHint(); revealCartDot(); maybeWelcome(); }

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('pageshow', run);
  document.addEventListener('cart:updated', run);
  document.addEventListener('ajaxProduct:added', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:render', run);
  document.addEventListener('drawer:open', run);
  document.addEventListener('drawer:opened', run);

  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    var mo = new MutationObserver(run);
    mo.observe(drawer, { childList: true, subtree: true });
  }

  // Öffentlicher Schalter (für Reminder/Welcome + Debugging).
  window.KBNGift = {
    isActive: isActive,
    activate: activate,
    welcome: runWelcome,                 // Begrüßung manuell auslösen (Test)
    resetWelcome: function () {           // Welcome-Flag löschen → feuert wieder
      try { localStorage.removeItem(WELCOME_KEY); } catch (e) {}
    },
    deactivate: function () {
      try {
        localStorage.removeItem(FLAG_KEY);
        localStorage.removeItem(UNTIL_KEY);
        localStorage.removeItem(WELCOME_KEY);
      } catch (e) {}
    },
    debug: function () {
      return { eg: readEgActive(), fallback: fallbackActive(), welcomed: alreadyWelcomed(), ttlDays: ttlMs() / 86400000, raw: lsGet(EG_RULES_KEY) };
    }
  };
})();
